import axios from 'axios';

const api = '/api/calendar-events';

export const getAllEvents = () => {
  return axios.get(`${api}/all?cacheBuster=${new Date().getTime()}`);
};

export const saveCalendarEvent = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const updateCalendarEvent = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};

export const deleteCalendarEvent = id => {
  return axios.delete(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};
